import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const AbajoRec = () => {
  
    const history = useHistory();

    const data = history.location.state;

   // console.log('data viene: ', data);

    const sendTagLocator = () => {
          history.push("/locator");
    }

    const regresaRecarga = () =>{
        history.push("/recarga");
    }


    useEffect(() => {
        async  function fetchInitialData() {
          if (data) {
            
          }else{
            history.push("/recarga");
          }
        }
        fetchInitialData();
        
      }, []);





  return (
    <>
    <Helmet>
        <title>Recargas Unefon</title>
      </Helmet>
    
    <div className="contenedorPromociones">

        <>
            <div className="logoUnefon animate__animated animate__slideInLeft"></div>
            <div className="promo expirada">
                        
            <div className="titulo">Servicio de pago no disponible.</div>
            <div className="legalRecarga">Recuerda que puedes realizar tu recarga en tu tienda favorita o en mi AT&T.</div>
        
        </div>

            
        </>  
        <div onClick={regresaRecarga} className='button button--telesto'><span>Recarga otro número</span></div>
    </div>
    </>
  )
}

